import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { SelectInput, TextInput, maxLength, required, useTranslate } from 'react-admin';
import { DateRangeInput } from '@/components/global/inputs/DateRangeInput.jsx';
import { Palette } from '@/themes/themeOverrides/Palette';
import { useFormContext, useWatch } from 'react-hook-form';
import { useCallback } from 'react';
import SelectWithIcon from '@/components/global/inputs/SelectWithIcon';
import { serviceRequestPriorityChoices } from '@/components/global/options/selectOptions.jsx';
import { couponValidityChoices } from '@/constants/CampaignSteps';
import ImportImageInput from '@/components/global/inputs/ImportImageInput.jsx';

const EmissionStep = () => {
    const translate = useTranslate();
    const { setValue } = useFormContext();
    const start = useWatch({ name: 'startDate' });
    const end = useWatch({ name: 'endDate' });

    const handleChange = useCallback(
        ({ start: nextStart, end: nextEnd }) => {
            setValue('startDate', nextStart, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
            setValue('endDate', nextEnd, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
        },
        [setValue],
    );

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '32px',
                width: '492px',
                '& .range-picker-label': {
                    backgroundColor: Palette.white,
                },
                '& .RaLabeled-label': {
                    display: 'none',
                },
            }}
        >
            <DateRangeInput start={start} end={end} onChange={handleChange} />
            <SelectWithIcon
                source='priority'
                label={translate('common.priorityLabel')}
                className='select-with-icon select-with-icon--outlined'
                colorChoices={serviceRequestPriorityChoices(translate)}
                defaultValue='normal'
                sx={{
                    width: '199px',
                    '& .MuiFormHelperText-root': {
                        display: 'none',
                    },
                }}
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={!!useWatch({ name: 'sponsored' })}
                        onChange={(_, checked) => setValue('sponsored', checked, { shouldDirty: true, shouldTouch: true, shouldValidate: true })}
                    />
                }
                label={translate('resources.campaign.labels.sponsored')}
                sx={{
                    '& .MuiFormControlLabel-label': {
                        fontSize: '14px',
                    },
                }}
            />
            <ImportImageInput source='image' accept='.jpg,.jpeg,.png' placeholderText={translate('resources.campaign.labels.couponImagePlaceholder')} />
            <SelectInput
                source='imageDisplayDays'
                label={translate('resources.campaign.labels.couponValidity')}
                choices={couponValidityChoices}
                optionValue='id'
                optionText='name'
                defaultValue={7}
                validate={required()}
                sx={{
                    width: '199px',
                    '& .MuiFormHelperText-root': { display: 'none' },
                }}
            />
            <TextInput
                source='deviceDescription'
                label={translate('resources.campaign.fields.couponDescription')}
                validate={maxLength(80, translate('common.validation.maxLength', { count: 80 }))}
                fullWidth
            />
        </Box>
    );
};

export default EmissionStep;
